import { Stack, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { DraggableProvided } from "react-beautiful-dnd"
import EmbedSlice from "../../../models/bodySlices/embedSlice"
import ImageSlice from "../../../models/bodySlices/imageSlice"
import QuoteSlice from "../../../models/bodySlices/quoteSlice"
import TextSlice from "../../../models/bodySlices/textSlice"
import { MediaSize } from "../../../services/config/enum"
import ImagePicker from "../../global/imagePicker"
import SliceTitle from "../common/sliceTitle"
import SliceWrapper from "../common/sliceWrapper"
import { isValidURL } from "../utilities/isValidUrl"

const ImageSliceComponent = ({
  item,
  body,
  setBody,
  editMode,
  sliceIndex,
  removeSlice,
  provided,
}: {
  item: ImageSlice
  body: (EmbedSlice | ImageSlice | QuoteSlice | TextSlice)[]
  setBody: (body: (EmbedSlice | ImageSlice | QuoteSlice | TextSlice)[]) => void
  editMode: boolean
  sliceIndex: number
  removeSlice: (sliceToRemoveIndex: number) => void
  provided: DraggableProvided
}) => {
  // states
  const [imgUrl, setImgUrl] = useState<string>(item.imgUrl)
  const [imgCaption, setImgCaption] = useState<string | null>(item.imgCaption)
  const [imgCaptionTitle, setImgCaptionTitle] = useState<string | null>(
    item.imgCaptionTitle
  )

  // update states state when body changes
  useEffect(() => {
    if (item.imgUrl !== imgUrl) {
      setImgUrl(item.imgUrl)
    }
    if (item.imgCaption !== imgCaption) {
      setImgCaption(item.imgCaption)
    }
    if (item.imgCaptionTitle !== imgCaptionTitle) {
      setImgCaptionTitle(item.imgCaptionTitle)
    }
  }, [item])

  // update body when states change
  useEffect(() => {
    if (
      item.imgUrl !== imgUrl ||
      item.imgCaption !== imgCaption ||
      item.imgCaptionTitle !== imgCaptionTitle
    ) {
      item.imgUrl = imgUrl
      item.imgCaption = imgCaption
      item.imgCaptionTitle = imgCaptionTitle
      setBody(body)
    }
  }, [imgUrl, imgCaption, imgCaptionTitle])

  // errors
  const [imgUrlError, setImgUrlError] = useState<boolean>(false)

  useEffect(() => {
    if (!imgUrl.length || !isValidURL(imgUrl)) {
      setImgUrlError(true)
    } else {
      setImgUrlError(false)
    }
  }, [imgUrl])

  return (
    <SliceWrapper
      editMode={editMode}
      sliceIndex={sliceIndex}
      removeSlice={removeSlice}
      provided={provided}
    >
      <SliceTitle>Image</SliceTitle>
      <Stack direction="row" spacing={1}>
        <ImagePicker
          title="Image"
          error={imgUrlError}
          pickedImage={imgUrl}
          setPickedImage={(selectedImage: {
            url: string
            id: string
            description?: string
            type?: MediaSize
          }) => {
            setImgUrl(selectedImage.url)
          }}
          filters={{ category: "other" }}
          width="50%"
          height={88}
          disabled={!editMode}
        />
        <Stack spacing={1} style={{ width: "50%" }}>
          <TextField
            fullWidth
            size="small"
            label="Caption title"
            value={imgCaptionTitle ?? ""}
            onChange={(e) => {
              if (e.target.value.length) {
                setImgCaptionTitle(e.target.value)
              } else {
                setImgCaptionTitle(null)
              }
            }}
            disabled={!editMode}
          />
          <TextField
            fullWidth
            size="small"
            label="Caption"
            value={imgCaption ?? ""}
            onChange={(e) => {
              if (e.target.value.length) {
                setImgCaption(e.target.value)
              } else {
                setImgCaption(null)
              }
            }}
            disabled={!editMode}
          />
        </Stack>
      </Stack>
    </SliceWrapper>
  )
}

export default ImageSliceComponent
